var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class=\"cotacao-page-section\">\r\n    Ocorreu um erro inesperado!\r\n</section>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./resources/templates/pages/error.hbs
// module id = 216
// module chunks = 0